var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F31C54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1707 19.9637C38.7462 19.7102 39.3683 19.5795 39.9973 19.5801C40.6258 19.5802 41.2473 19.7114 41.8223 19.9651C42.3973 20.2189 42.9131 20.5897 43.3368 21.054C43.7605 21.5182 44.0827 22.0656 44.283 22.6614C44.4833 23.2571 44.5573 23.888 44.5002 24.5139L42.697 44.3583C42.6269 45.0255 42.3123 45.6431 41.8137 46.092C41.3152 46.5409 40.6681 46.7893 39.9973 46.7893C39.3264 46.7893 38.6793 46.5409 38.1808 46.092C37.6823 45.6431 37.3676 45.0255 37.2975 44.3583L35.4894 24.5139C35.4323 23.8876 35.5063 23.2563 35.7069 22.6602C35.9075 22.0641 36.2303 21.5165 36.6545 21.0521C37.0787 20.5878 37.5951 20.2171 38.1707 19.9637Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3187 55.2589C44.3187 57.6454 42.384 59.5801 39.9975 59.5801C37.6109 59.5801 35.6763 57.6454 35.6763 55.2589C35.6763 52.8723 37.6109 50.9377 39.9975 50.9377C42.384 50.9377 44.3187 52.8723 44.3187 55.2589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a45f2486d68137855586afaee06b019d.svg";
export { ForwardRef as ReactComponent };